/**
 * 消息子类型枚举
 */
export enum MessageSubType {
  /** 职位发布 */
  JOB_PUBLISH = 1,
  /** 职位开放 */
  JOB_OPEN = 2,
  /** 职位关闭 */
  JOB_CLOSE = 3,
  /** 新投递 */
  NEW_APPLICATION = 10,
  /** 选考状态变更 */
  SELECTION_STATUS_CHANGE = 11,
  /** 面试日程已发出 */
  INTERVIEW_SCHEDULE_SENT = 12,
  /** 面试日程已接受 */
  INTERVIEW_SCHEDULE_ACCEPTED = 13,
  /** 面试日程待调整 */
  INTERVIEW_SCHEDULE_PENDING = 14,
  /** 面试日程已调整 */
  INTERVIEW_SCHEDULE_ADJUSTED = 15,
  /** 面试日程已过期 */
  INTERVIEW_SCHEDULE_EXPIRED = 16,
  /** 面试日程重新预约 */
  INTERVIEW_SCHEDULE_RESCHEDULED = 17,
  /** 确认入职日期 */
  CONFIRM_JOIN_DATE = 18,
  /** 确认入职 */
  CONFIRM_JOIN = 19,
  /** 选考终止 */
  SELECTION_TERMINATE = 20,
  /** 内部留言 */
  INTERNAL_COMMENT = 21,
  /** 外部联络 */
  EXTERNAL_CONTACT = 22
}

export enum DefaultVirRole {
  candidateOwner = 101,
  selectionOwner = 102,
}
/**
 * 消息类型枚举
 */
export enum MessageType {
  /** 通知 */
  NOTIFICATION = 1,
  /** 公告 */
  ANNOUNCEMENT = 2
}

/**
 * 消息分类枚举
 */
export enum MessageCategory {
  /** 职位 */
  JOB = 1,
  /** 选考 */
  SELECTION = 2
}
